var _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmallClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 0,
    fill: "#D8D8D8",
    fillOpacity: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16,
    rx: 8,
    ry: 8,
    fill: "#000000",
    fillOpacity: 0.4000000059604645
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 16,
    rx: 7.5,
    ry: 7.5,
    fillOpacity: 0,
    strokeOpacity: 0.20000000298023224,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.95114,16L19.80399,13.14733C20.06534,12.885333,20.06534,12.458,19.80399,12.196C19.54264,11.9346667,19.11461,11.9346667,18.85326,12.196L15.99975,15.04933L13.14691,12.196C12.884889,11.9346667,12.457529,11.9346667,12.195512,12.196C11.9348293,12.458,11.9348293,12.885333,12.195512,13.14733L15.04836,16L12.195512,18.85267C11.9348293,19.114,11.9348293,19.542,12.195512,19.804000000000002C12.457529,20.06533,12.884889,20.06533,13.14691,19.804000000000002L15.99975,16.95067L18.85326,19.804000000000002C19.11461,20.06533,19.54264,20.06533,19.80399,19.804000000000002C20.06534,19.542,20.06534,19.114,19.80399,18.85267L16.95114,16Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmallClose);
export default __webpack_public_path__ + "static/media/icon-small-close.f4696be8.svg";
export { ForwardRef as ReactComponent };